module.exports = __webpack_public_path__ + "img/EE.f6db7992.svg";